// src/features/october/constants/productConstants.js

export const CATEGORIES_DATA = [
  { id: 'all', name: 'All Products', icon: '🌟' },
  { id: 'perfumes', name: 'Perfumes', icon: '🌺' },
  { id: 'candles', name: 'Candles', icon: '🕯️' },
  { id: 'diffusers', name: 'Diffuser', icon: '💨' },
  { id: 'room-mist', name: 'Room Mist', icon: '✨' },
  { id: 'bath', name: 'Bath', icon: '🛁' },
  { id: 'others', name: 'Others', icon: '📦' }
];

export const GENDER_FILTERS = [
  { id: 'all', name: 'All' },
  { id: 'male', name: 'For Him' },
  { id: 'female', name: 'For Her' },
  { id: 'unisex', name: 'Unisex' }
];

export const INTENSITY_FILTERS = [
  { id: 'all', name: 'All Intensities' },
  { id: 'Light', name: 'Light' },
  { id: 'Medium', name: 'Medium' },
  { id: 'Heavy', name: 'Heavy' },
  { id: 'Very Heavy', name: 'Very Heavy' }
];

// Updated TYPE_FILTERS to include candle and diffuser specific types
export const TYPE_FILTERS = [
  { id: 'all', name: 'All Types' },
  // Perfume types
  { id: 'Oriental', name: 'Oriental', category: 'perfumes' },
  { id: 'Fruity Floral', name: 'Fruity Floral', category: 'perfumes' },
  { id: 'Amber Woody', name: 'Amber Woody', category: 'perfumes' },
  { id: 'Fougere Amber Woody', name: 'Fougere Amber Woody', category: 'perfumes' },
  { id: 'Floral Fruity', name: 'Floral Fruity', category: 'perfumes' },
  { id: 'Fresh Woody Floral', name: 'Fresh Woody Floral', category: 'perfumes' },
  { id: 'Tobacco Gourmand', name: 'Tobacco Gourmand', category: 'perfumes' },
  { id: 'Woody Aromatic', name: 'Woody Aromatic', category: 'perfumes' },
  { id: 'Fresh Aquatic', name: 'Fresh Aquatic', category: 'perfumes' },
  // Candle types
  { id: 'Soy Wax', name: 'Soy Wax', category: 'candles' },
  { id: 'Paraffin Wax', name: 'Paraffin Wax', category: 'candles' },
  { id: 'Beeswax', name: 'Beeswax', category: 'candles' },
  { id: 'Coconut Wax', name: 'Coconut Wax', category: 'candles' },
  // Diffuser types
  { id: 'Reed Diffuser', name: 'Reed Diffuser', category: 'diffusers' },
  { id: 'Electric Diffuser', name: 'Electric Diffuser', category: 'diffusers' },
  { id: 'Ultrasonic Diffuser', name: 'Ultrasonic Diffuser', category: 'diffusers' },
  { id: 'Car Diffuser', name: 'Car Diffuser', category: 'diffusers' },
  // Room Mist types
  { id: 'Spray Mist', name: 'Spray Mist', category: 'room-mist' },
  { id: 'Fine Mist', name: 'Fine Mist', category: 'room-mist' },
  { id: 'Aerosol Mist', name: 'Aerosol Mist', category: 'room-mist' },
  // Bath types
  { id: 'Bath Bombs', name: 'Bath Bombs', category: 'bath' },
  { id: 'Bath Salts', name: 'Bath Salts', category: 'bath' },
  { id: 'Bath Oil', name: 'Bath Oil', category: 'bath' },
  { id: 'Bubble Bath', name: 'Bubble Bath', category: 'bath' },
  { id: 'Body Wash', name: 'Body Wash', category: 'bath' },
  { id: 'Body Scrub', name: 'Body Scrub', category: 'bath' },
  // Others types
  { id: 'General', name: 'General', category: 'others' },
  { id: 'Accessories', name: 'Accessories', category: 'others' }
];

// Helper function to get types by category
export const getTypesByCategory = (categoryId) => {
  if (categoryId === 'all') return TYPE_FILTERS;
  return TYPE_FILTERS.filter(type => type.category === categoryId || type.id === 'all');
};

export const SORT_OPTIONS = [
  { id: 'newest', name: 'Newest First' },
  { id: 'oldest', name: 'Oldest First' },
  { id: 'name-asc', name: 'Name A-Z' },
  { id: 'name-desc', name: 'Name Z-A' },
  { id: 'price-low', name: 'Price Low to High' },
  { id: 'price-high', name: 'Price High to Low' },
  { id: 'rating-high', name: 'Highest Rated' },
  { id: 'rating-low', name: 'Lowest Rated' },
  { id: 'featured', name: 'Featured First' }
];

export const PRICE_RANGES = [
  { id: 'all', name: 'All Prices', min: 0, max: Infinity },
  { id: 'under-200', name: 'Under R200', min: 0, max: 199 },
  { id: '200-300', name: 'R200 - R300', min: 200, max: 300 },
  { id: '300-500', name: 'R300 - R500', min: 300, max: 500 },
  { id: 'over-500', name: 'Over R500', min: 500, max: Infinity }
];

// Category-specific attributes
export const CATEGORY_ATTRIBUTES = {
  perfumes: {
    name: 'Perfumes',
    attributes: ['intensity', 'longevity', 'sillage', 'season', 'notes'],
    defaultIntensity: 'Medium',
    defaultLongevity: '6-8 hours',
    defaultSillage: 'Moderate'
  },
  candles: {
    name: 'Candles',
    attributes: ['burnTime', 'roomSize', 'waxType', 'wickType'],
    defaultBurnTime: '40-50 hours',
    defaultRoomSize: 'Medium (20-30 sqm)',
    defaultWaxType: 'Soy Wax',
    defaultWickType: 'Cotton Wick'
  },
  diffusers: {
    name: 'Diffuser',
    attributes: ['coverage', 'duration', 'diffuserType', 'capacity'],
    defaultCoverage: '25-30 sqm',
    defaultDuration: '8-12 weeks',
    defaultDiffuserType: 'Reed Diffuser',
    defaultCapacity: '100ml'
  },
  'room-mist': {
    name: 'Room Mist',
    attributes: ['coverage', 'duration', 'capacity', 'sprayType'],
    defaultCoverage: '20-25 sqm',
    defaultDuration: '4-6 weeks',
    defaultCapacity: '100ml',
    defaultSprayType: 'Spray Mist'
  },
  bath: {
    name: 'Bath',
    attributes: ['size', 'scentProfile', 'skinType'],
    defaultSize: 'Regular',
    defaultScentProfile: 'Floral',
    defaultSkinType: 'All Skin Types'
  },
  others: {
    name: 'Others',
    attributes: ['productType', 'dimensions'],
    defaultProductType: 'General',
    defaultDimensions: ''
  }
};

// Updated default product structure
export const DEFAULT_PRODUCT = {
  name: '',
  category: 'perfumes', // Default to perfumes
  type: 'Oriental',
  price: 'R300',
  priceValue: 300,
  rating: 4.5,
  reviews: 0,
  description: '',
  // Perfume specific
  notes: {
    top: [],
    heart: [],
    base: []
  },
  intensity: 'Medium',
  longevity: '6-8 hours',
  sillage: 'Moderate',
  season: 'All Seasons',
  // Candle specific
  burnTime: '',
  roomSize: '',
  waxType: '',
  wickType: '',
  // Diffuser specific
  coverage: '',
  duration: '',
  diffuserType: '',
  capacity: '',
  // Room Mist specific
  sprayType: '',
  // Bath specific
  size: '',
  scentProfile: '',
  skinType: '',
  // Others specific
  productType: '',
  dimensions: '',
  // Common
  inStock: true,
  featured: false,
  image: '',
  imagePath: ''
};